angular
	.module('pwc', [
		'pouchdb',
		'ngLodash',
		'ngMaterial',
		'ngSanitize',
		'slugifier',
		'ngMessages',
		'ui.router',
		'ngFileUpload',
		'angular.filter',
		'stripe.checkout',
		'blndspt.ngPerformance',
		'ngStorage',
		'ngFileSaver',
		'tandibar/ng-rollbar',
		'angulartics',
		'angulartics.mixpanel',
		//'cloudinary',
		// begin app deps
		'pwc.utils',
		'templates',
		'pwc.environment',
		'pwc.api',
		'pwc.controllers',
		'pwc.directives',
		'pwc.filters',
		'pwc.data',
		'pwc.model',
		'pwc.repositories',
		'pwc.events',
		'pwc.pouch.user',
		'pwc.pouch.system',
		'pwc.agingPotential',
		'pwc.services.connection',
		'pwc.services.wineTable',
		'pwc.services.message',
		'pwc.services.barcode',
		'pwc.services.dialog',
		'pwc.services.intercom',
		'pwc.state'
	])
	// the app.min.js SHA is from RevAll in gulpfile.js
	.constant('BUILD_NUMBER', 'js/app.min.js'.slice(-6))
	.config(configure)
	.run(runBlock);

configure.$inject = ['$stateProvider', '$compileProvider', '$httpProvider', '$urlRouterProvider', '$mdThemingProvider', 'pouchDBProvider', 'POUCHDB_METHODS', '$mdGestureProvider', '$logProvider', 'lodash', 'BUILD_NUMBER', '$mdDateLocaleProvider', '$provide', '$localStorageProvider', 'RollbarProvider', 'ENVProvider', '$mdInkRippleProvider', '$analyticsProvider', '$locationProvider'];

function configure($stateProvider, $compileProvider, $httpProvider, $urlRouterProvider, $mdThemingProvider, pouchDBProvider, POUCHDB_METHODS, $mdGestureProvider, $logProvider, lodash, BUILD_NUMBER, $mdDateLocaleProvider, $provide, $localStorageProvider, RollbarProvider, ENVProvider, $mdInkRippleProvider, $analyticsProvider, $locationProvider) {

	var ENV = ENVProvider.$get();

    $locationProvider.hashPrefix('');

	$logProvider.debugEnabled(ENV.DEBUG);

	$compileProvider.debugInfoEnabled(false);

	$mdInkRippleProvider.disableInkRipple();

	$analyticsProvider.virtualPageviews(false);

	$analyticsProvider.developerMode(ENV.DEBUG);

	RollbarProvider.init({
		accessToken: "2d3819f06f7c4d72ad3f8b4dc925b26d",
		captureUncaught: true,
		autoInstrument: true,
		ignoredMessages: ['Database encountered an unknown error'],
		payload: {
			environment: ENV.NAME,
			client: {
				javascript: {
					source_map_enabled: true,
					code_version: BUILD_NUMBER,
					guess_uncaught_frames: true
				}
			}
		}
	});

	$localStorageProvider.setKeyPrefix('PWC');

	$provide.decorator('$log', function ( $delegate ){
		$delegate.isEnabled = $logProvider.debugEnabled();
		return $delegate;
	});

	$mdDateLocaleProvider.parseDate = function(dateString) {
		var m = moment(dateString, 'L', true);
		return m.isValid() ? m.toDate() : new Date(NaN);
	};

	$mdDateLocaleProvider.formatDate = function(date) {
		if (lodash.isNull(date)){
			return null;
		}
		return moment(date).format('L');
	};

	function isNotEmptyOrNull(val){
		return angular.isDefined(val) && ! lodash.isNull(val) && val !== '';
	}

	function isEmptyOrNull(val){
		return ! isNotEmptyOrNull(val);
	}

	lodash.mixin({ 'isNotEmptyOrNull': isNotEmptyOrNull, 'isEmptyOrNull': isEmptyOrNull });

	/**
	 * moment#getMonthNameFromInt
	 *
	 * extend moment to get month names from month int's. This is helpful when you have to sort Jan - Dec, it's easier
	 * when it's a month int, but then need to display the full month
	 *
	 * usage: `moment().getMonthNameFromInt(12);` returns "December"
	 *
	 * The Moment prototype is exposed through `moment.fn.` If you want to add your own functions, that is where you
	 * would put them. Src: http://momentjs.com/docs/#/parsing/
	 *
	 * @param Int monthInt
	 * @returns String FullMonthName
     */
	moment.fn.getMonthNameFromInt = function (monthInt) {
		// moment expects a 0-based month, subtract 1.
		return moment().month(monthInt - 1).format('MMMM');
	};

	$httpProvider.defaults.useXDomain = true;

	delete $httpProvider.defaults.headers.common['X-Requested-With'];

	$mdGestureProvider.skipClickHijack();

	var authMethods = {
		login: 'qify',
		logout: 'qify',
		getUser: 'qify'
	};

	pouchDBProvider.methods = angular.extend({}, POUCHDB_METHODS, authMethods);

	var userTheme = $localStorageProvider.get('theme');

	$mdThemingProvider.theme('default')
		.primaryPalette(lodash.get(userTheme, 'primary', 'blue'))
		.accentPalette(lodash.get(userTheme, 'accent', 'pink'));

    $compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|mailto|file|tel|content):/);

    $compileProvider.imgSrcSanitizationWhitelist(/^\s*(https?|mailto|file|tel|content|blob):|data:image|/);

    $stateProvider
		// non logged in states
		.state('login', {
			url: '/login',
			data: {
				title: 'Login to Personal Wine Curator'
			},
            resolve: { /* @ngInject */
                "activeUserCheck": function(userPouch, $log, Utils){
                    return userPouch.hasActiveSession()
                        .then(function(resp){
                            // user has valid session, send to wines
                            return Utils.go('wines');
                        })
                        .catch(function(err) {
                            $log.debug("No valid session.");
                            return false;
                        });
                }
			},
			"views": {
				"main": {
					templateUrl: 'templates/login.html',
					controller: 'UserController as user'
				}
			}
		})
		.state('join', {
			url: '/join',
			data: {
				title: "Join Personal Wine Curator"
			},
			"views": {
				"main": {
					templateUrl: 'templates/join.html',
					controller: 'JoinController as join'
				}
			}
		})
		.state('join/plan_code', {
			url: '/join/:plan_code',
			data: {
				title: "Join Personal Wine Curator"
			},
			"views": {
				"main": {
					templateUrl: 'templates/join.html',
					controller: 'JoinController as join'
				}
			}
		})
		.state('gift', {
			url: '/gift',
			data: {
				title: "Gift Personal Wine Curator"
			},
			"views": {
				"main": {
					templateUrl: 'templates/gift.html',
					controller: 'GiftController as gift'
				}
			}
		})
		.state('billing', {
			url: '/billing',
			data: {
				title: "Update Credit Card"
			},
            resolve: { /* @ngInject */
                "activeUser": function(userPouch){
                    return userPouch.assertActiveUserAndBootstrap();
                }
            },
			"views": {
				"main": {
					templateUrl: 'templates/billing.html',
					controller: 'BillingController as billing'
				}
			}
		})
		.state('latest', {
			url: '/latest',
			data: {
				title: "What's New with PWC"
			},
			resolve: { /* @ngInject */
				"activeUser": function(userPouch){
					return userPouch.assertActiveUserAndBootstrap();
				}
			},
			"views": {
				"main": {
					templateUrl: 'templates/latest.html'
				}
			}
		})
		.state('import', {
			url: '/import',
			data: {
				title: "Import data from PWC 3.5"
			},
			"views": {
				"main": {
					templateUrl: 'templates/import.html',
				}
			}
		})
		.state('wines', {
			url: '/wines',
			data: {
				title: 'Wines'
			},
			resolve: { /* @ngInject */
				"activeUser": function(userPouch){
					return userPouch.assertActiveUserAndBootstrap();
				}
			},
			"views": {
				"subheader": {
					templateUrl: 'templates/crud/wines-list-header.html',
					controller: 'WinesListHeaderController as header'
				},
				"footer": {
					templateUrl: 'templates/crud/wines-list-footer.html',
					controller: 'WinesListFooterController as footer'
				},
				"main": {
					templateUrl: 'templates/crud/wines-list-virtual.html',
					controller: 'WinesListController as list'
				}
			}
		})
		.state('wines/add', {
			url: '/wines/add',
			data: {
				title: 'Add new Wine'
			},
			resolve: { /* @ngInject */
				"activeUser": function(userPouch){
					return userPouch.assertActiveUserAndBootstrap();
				}
			},
			"views": {
				"main": {
					templateUrl: 'templates/crud/wines-add.html',
					controller: 'WineBaseAddEditController as edit'
				}
				//"footer": {templateUrl: 'templates/crud/wines-add-footer.html'}
			}
		})
        .state('wines/copy', {
            url: '/wines/copy/:id',
			data: {
				title: 'Copy Wine'
			},
			resolve: { /* @ngInject */
				"activeUser": function(userPouch){
					return userPouch.assertActiveUserAndBootstrap();
				}
			},
			"views": {
				"main": {
					templateUrl: 'templates/crud/wines-add.html',
					controller: 'WineBaseAddEditController as edit'
				},
				"subheader": {
					templateUrl: 'templates/crud/wines-copy-header.html'
				}
			}
        })
		.state('wines/edit', {
			url: '/wines/edit/:id/:tab',
			data: {
				title: "Edit Wine"
			},
			resolve: { /* @ngInject */
				"activeUser": function(userPouch){
					return userPouch.assertActiveUserAndBootstrap();
				}
			},
			"views": {
				"main": {
					controller: 'WineBaseAddEditController as edit',
					templateUrl: 'templates/crud/wines-edit.html'
				}
			}
		})
		.state('wines/print', {
			url: '/wines/print',
			data: {
				title: 'Print Active Wine List'
			},
			resolve: { /* @ngInject */
				"activeUser": function(userPouch){
					return userPouch.assertActiveUserAndBootstrap();
				}
			},
			"views": {
				"main": {
					templateUrl: 'templates/print-wines.html',
					controller: 'WinesListController as list'
				}
			}
		})
        .state('wines/print/wine', {
            url: '/wines/print/wine/:id',
            data: {
                title: 'Print Wine'
            },
            resolve: { /* @ngInject */
                "activeUser": function(userPouch){
                    return userPouch.assertActiveUserAndBootstrap();
                }
            },
            "views": {
                "main": {
                    templateUrl: 'templates/print-wine.html',
                    controller: 'WinesPrintController as print'
                }
            }
        })
		.state('pair/wine', {
			url: '/pair/wine',
			data: {
				title: "Pair Wine with Food"
			},
			resolve: { /* @ngInject */
				"activeUser": function(userPouch){
					return userPouch.assertActiveUserAndBootstrap();
				}
			},
			"views": {
				"main": {
					templateUrl: 'templates/pair/wine.html',
					controller: 'PairWineController as pair'
				}
			}
		})
		.state('pair/food', {
			url: '/pair/food',
			data: {
				title: "Pair Food with Wine"
			},
			resolve: { /* @ngInject */
				"activeUser": function(userPouch){
					return userPouch.assertActiveUserAndBootstrap();
				}
			},
			"views": {
				"main": {
					templateUrl: 'templates/pair/food.html',
					controller: 'PairFoodController as pair'
				}
			}
		})
		.state('reports/summary', {
			url: '/reports/summary',
			data: {
				title: 'Wine Cellar Summary Report'
			},
			resolve: { /* @ngInject */
				"activeUser": function(userPouch){
					return userPouch.assertActiveUserAndBootstrap();
				}
			},
			"views": {
				"main": {
					templateUrl: 'templates/reports/cellar-summary.html',
					controller: 'CellarSummaryReportController as report'
				}
			}
		})
		.state('reports/winetype/summary', {
			url: '/reports/winetype/summary',
			data: {
				title: 'Wine Type Summary Report'
			},
			resolve: { /* @ngInject */
				"activeUser": function(userPouch){
					return userPouch.assertActiveUserAndBootstrap();
				}
			},
			"views": {
				"main": {
					templateUrl: 'templates/reports/wine-type-summary.html',
					controller: 'WineTypeSummaryReportController as report'
				}
			}
		})
		.state('reports/winetype/detail', {
			url: '/reports/winetype/detail',
			data: {
				title: 'Wine Type Detail Report'
			},
			resolve: { /* @ngInject */
				"activeUser": function(userPouch){
					return userPouch.assertActiveUserAndBootstrap();
				}
			},
			"views": {
				"main": {
					templateUrl: 'templates/reports/wine-type-detail.html',
					controller: 'WineTypeDetailReportController as report'
				}
			}
		})
		.state('reports/body/summary', {
			url: '/reports/body/summary',
			data: {
				title: 'Body Summary Report'
			},
			resolve: { /* @ngInject */
				"activeUser": function(userPouch){
					return userPouch.assertActiveUserAndBootstrap();
				}
			},
			"views": {
				"main": {
					templateUrl: 'templates/reports/body-summary.html',
					controller: 'BodySummaryReportController as report'
				}
			}
		})
		.state('reports/body/detail', {
			url: '/reports/body/detail',
			data: {
				title: 'Body Detail Report'
			},
			resolve: { /* @ngInject */
				"activeUser": function(userPouch){
					return userPouch.assertActiveUserAndBootstrap();
				}
			},
			"views": {
				"main": {
					templateUrl: 'templates/reports/body-detail.html',
					controller: 'BodyDetailReportController as report'
				}
			}
		})
		.state('reports/ratings/detail', {
			url: '/reports/ratings/detail',
			data: {
				title: 'Ratings Detail Report'
			},
			resolve: { /* @ngInject */
				"activeUser": function(userPouch){
					return userPouch.assertActiveUserAndBootstrap();
				}
			},
			"views": {
				"main": {
					templateUrl: 'templates/reports/ratings-detail.html',
					controller: 'RatingsDetailReportController as report'
				}
			}
		})
		.state('reports/maturity/summary', {
			url: '/reports/maturity/summary',
			data: {
				title: 'Maturity Summary Report'
			},
			resolve: { /* @ngInject */
				"activeUser": function(userPouch){
					return userPouch.assertActiveUserAndBootstrap();
				}
			},
			"views": {
				"main": {
					templateUrl: 'templates/reports/maturity-summary.html',
					controller: 'MaturitySummaryReportController as report'
				}
			}
		})
		.state('reports/maturity/detail', {
			url: '/reports/maturity/detail',
			data: {
				title: 'Maturity Detail Report'
			},
			resolve: { /* @ngInject */
				"activeUser": function(userPouch){
					return userPouch.assertActiveUserAndBootstrap();
				}
			},
			"views": {
				"main": {
					templateUrl: 'templates/reports/maturity-detail.html',
					controller: 'MaturityDetailReportController as report'
				}
			}
		})
		.state('reports/producer/summary', {
			url: '/reports/producer/summary',
			data: {
				title: 'Producer Summary Report'
			},
			resolve: { /* @ngInject */
				"activeUser": function(userPouch){
					return userPouch.assertActiveUserAndBootstrap();
				}
			},
			"views": {
				"main": {
					templateUrl: 'templates/reports/producer-summary.html',
					controller: 'ProducerSummaryReportController as report'
				}
			}
		})
		.state('reports/producer/detail', {
			url: '/reports/producer/detail',
			data: {
				title: 'Producer Detail Report'
			},
			resolve: { /* @ngInject */
				"activeUser": function(userPouch){
					return userPouch.assertActiveUserAndBootstrap();
				}
			},
			"views": {
				"main": {
					templateUrl: 'templates/reports/producer-detail.html',
					controller: 'ProducerDetailReportController as report'
				}
			}
		})
		.state('reports/varietal/summary', {
			url: '/reports/varietal/summary',
			data: {
				title: 'Varietal Summary Report'
			},
			resolve: { /* @ngInject */
				"activeUser": function(userPouch){
					return userPouch.assertActiveUserAndBootstrap();
				}
			},
			"views": {
				"main": {
					templateUrl: 'templates/reports/varietal-summary.html',
					controller: 'VarietalSummaryReportController as report'
				}
			}
		})
		.state('reports/varietal/detail', {
			url: '/reports/varietal/detail',
			data: {
				title: 'Varietal Detail Report'
			},
			resolve: { /* @ngInject */
				"activeUser": function(userPouch){
					return userPouch.assertActiveUserAndBootstrap();
				}
			},
			"views": {
				"main": {
					templateUrl: 'templates/reports/varietal-detail.html',
					controller: 'VarietalDetailReportController as report'
				}
			}
		})
		.state('reports/distinction/summary', {
			url: '/reports/distinction/summary',
			data: {
				title: 'Distinction Summary Report'
			},
			resolve: { /* @ngInject */
				"activeUser": function(userPouch){
					return userPouch.assertActiveUserAndBootstrap();
				}
			},
			"views": {
				"main": {
					templateUrl: 'templates/reports/distinction-summary.html',
					controller: 'DistinctionSummaryReportController as report'
				}
			}
		})
		.state('reports/vintage/summary', {
			url: '/reports/vintage/summary',
			data: {
				title: 'Vintage Summary Report'
			},
			resolve: { /* @ngInject */
				"activeUser": function(userPouch){
					return userPouch.assertActiveUserAndBootstrap();
				}
			},
			"views": {
				"main": {
					templateUrl: 'templates/reports/vintage-summary.html',
					controller: 'VintageSummaryReportController as report'
				}
			}
		})
		.state('reports/vintage/detail', {
			url: '/reports/vintage/detail',
			data: {
				title: 'Vintage Detail Report'
			},
			resolve: { /* @ngInject */
				"activeUser": function(userPouch){
					return userPouch.assertActiveUserAndBootstrap();
				}
			},
			"views": {
				"main": {
					templateUrl: 'templates/reports/vintage-detail.html',
					controller: 'VintageDetailReportController as report'
				}
			}
		})
		.state('reports/subregion/summary', {
			url: '/reports/subregion/summary',
			data: {
				title: 'Subregion Summary Report'
			},
			resolve: { /* @ngInject */
				"activeUser": function(userPouch){
					return userPouch.assertActiveUserAndBootstrap();
				}
			},
			"views": {
				"main": {
					templateUrl: 'templates/reports/subregion-summary.html',
					controller: 'SubregionSummaryReportController as report'
				}
			}
		})
		.state('reports/subregion/detail', {
			url: '/reports/subregion/detail',
			data: {
				title: 'Subregion Detail Report'
			},
			resolve: { /* @ngInject */
				"activeUser": function(userPouch){
					return userPouch.assertActiveUserAndBootstrap();
				}
			},
			"views": {
				"main": {
					templateUrl: 'templates/reports/subregion-detail.html',
					controller: 'SubregionDetailReportController as report'
				}
			}
		})
		.state('reports/region/summary', {
			url: '/reports/region/summary',
			data: {
				title: 'Region Summary Report'
			},
			resolve: { /* @ngInject */
				"activeUser": function(userPouch){
					return userPouch.assertActiveUserAndBootstrap();
				}
			},
			"views": {
				"main": {
					templateUrl: 'templates/reports/region-summary.html',
					controller: 'RegionSummaryReportController as report'
				}
			}
		})
		.state('reports/region/detail', {
			url: '/reports/region/detail',
			data: {
				title: 'Region Detail Report'
			},
			resolve: { /* @ngInject */
				"activeUser": function(userPouch){
					return userPouch.assertActiveUserAndBootstrap();
				}
			},
			"views": {
				"main": {
					templateUrl: 'templates/reports/region-detail.html',
					controller: 'RegionDetailReportController as report'
				}
			}
		})
		.state('reports/country/summary', {
			url: '/reports/country/summary',
			data: {
				title: 'Country Summary Report'
			},
			resolve: { /* @ngInject */
				"activeUser": function(userPouch){
					return userPouch.assertActiveUserAndBootstrap();
				}
			},
			"views": {
				"main": {
					templateUrl: 'templates/reports/country-summary.html',
					controller: 'CountrySummaryReportController as report'
				}
			}
		})
		.state('reports/country/detail', {
			url: '/reports/country/detail',
			data: {
				title: 'Country Detail Report'
			},
			resolve: { /* @ngInject */
				"activeUser": function(userPouch){
					return userPouch.assertActiveUserAndBootstrap();
				}
			},
			"views": {
				"main": {
					templateUrl: 'templates/reports/country-detail.html',
					controller: 'CountryDetailReportController as report'
				}
			}
		})
		.state('reports/purchase/cost', {
			url: '/reports/purchase/cost',
			data: {
				title: 'Purchase Cost Report'
			},
			resolve: { /* @ngInject */
				"activeUser": function(userPouch){
					return userPouch.assertActiveUserAndBootstrap();
				}
			},
			"views": {
				"main": {
					templateUrl: 'templates/reports/purchase-cost.html',
					controller: 'PurchaseCostReportController as report'
				}
			}
		})
		.state('reports/purchase/producer', {
			url: '/reports/purchase/producer',
			data: {
				title: 'Purchases By Producer Report'
			},
			resolve: { /* @ngInject */
				"activeUser": function(userPouch){
					return userPouch.assertActiveUserAndBootstrap();
				}
			},
			"views": {
				"main": {
					templateUrl: 'templates/reports/purchase-producer.html',
					controller: 'PurchaseProducerReportController as report'
				}
			}
		})
		.state('reports/purchase/auction', {
			url: '/reports/purchase/auction',
			data: {
				title: 'Purchases By Auction House Report'
			},
			resolve: { /* @ngInject */
				"activeUser": function(userPouch){
					return userPouch.assertActiveUserAndBootstrap();
				}
			},
			"views": {
				"main": {
					templateUrl: 'templates/reports/purchase-auction-house.html',
					controller: 'PurchaseAuctionHouseReportController as report'
				}
			}
		})
		.state('reports/purchase/date', {
			url: '/reports/purchase/date',
			data: {
				title: 'Purchases By Date Report'
			},
			resolve: { /* @ngInject */
				"activeUser": function(userPouch){
					return userPouch.assertActiveUserAndBootstrap();
				}
			},
			"views": {
				"main": {
					templateUrl: 'templates/reports/purchase-date.html',
					controller: 'PurchaseDateReportController as report'
				}
			}
		})
		.state('reports/purchase/onorder', {
			url: '/reports/purchase/onorder',
			data: {
				title: 'Purchases On Order'
			},
			resolve: { /* @ngInject */
				"activeUser": function(userPouch){
					return userPouch.assertActiveUserAndBootstrap();
				}
			},
			"views": {
				"main": {
					templateUrl: 'templates/reports/purchase-onorder.html',
					controller: 'PurchaseOnOrderReportController as report'
				}
			}
		})
		.state('reports/drink/producer', {
			url: '/reports/drink/producer',
			data: {
				title: 'Drink History By Producer'
			},
			resolve: { /* @ngInject */
				"activeUser": function(userPouch){
					return userPouch.assertActiveUserAndBootstrap();
				}
			},
			"views": {
				"main": {
					templateUrl: 'templates/reports/drink-producer.html',
					controller: 'DrinkProducerReportController as report'
				}
			}
		})
		.state('reports/value', {
			url: '/reports/value',
			data: {
				title: 'Value Report'
			},
			resolve: { /* @ngInject */
				"activeUser": function(userPouch){
					return userPouch.assertActiveUserAndBootstrap();
				}
			},
			"views": {
				"main": {
					templateUrl: 'templates/reports/value.html',
					controller: 'ValueReportController as report'
				}
			}
		})
		.state('reports/value/gainLoss', {
			url: '/reports/value/gainLoss',
			data: {
				title: 'Value Gain/Loss Report'
			},
			resolve: { /* @ngInject */
				"activeUser": function(userPouch){
					return userPouch.assertActiveUserAndBootstrap();
				}
			},
			"views": {
				"main": {
					templateUrl: 'templates/reports/valueGainLoss.html',
					controller: 'ValueGainLossReportController as report'
				}
			}
		})
		.state('reports/value/monthly', {
			url: '/reports/value/monthly',
			data: {
				title: 'Monthly Value Snapshot'
			},
			resolve: { /* @ngInject */
				"activeUser": function(userPouch){
					return userPouch.assertActiveUserAndBootstrap();
				}
			},
			"views": {
				"main": {
					templateUrl: 'templates/reports/valueMonthly.html',
					controller: 'ValueMonthlyReportController as report'
				}
			}
		})
		.state('settings', {
			url: '/settings',
			data: {
				title: "My Settings"
			},
			resolve: { /* @ngInject */
				"activeUser": function(userPouch){
					return userPouch.assertActiveUserAndBootstrap();
				}
			},
			"views": {
				"main": {
					templateUrl: 'templates/settings.html',
					controller: 'SettingsController as settings'
				}
			}
		})
		.state('password/change', {
			url: '/password/change',
			data: {
				title: 'Change My Password'
			},
			resolve: { /* @ngInject */
				"activeUser": function(userPouch){
					return userPouch.assertActiveUserAndBootstrap();
				}
			},
			"views": {
				"main": {
					templateUrl: 'templates/passwordChange.html',
					controller: 'UserController as user'
				}
			}
		})
		.state('password/reset/username/key', {
			url: '/password/reset/:username/:key',
			data: {
				title: 'Reset My Password'
			},
			"views": {
				"main": {
					templateUrl: 'templates/passwordReset.html',
					controller: 'PasswordResetController as reset'
				}
			}
		})
		.state('password/recover', {
			url: '/password/recover',
			data: {
				title: 'Recover My Password'
			},
			"views": {
				"main": {
					templateUrl: 'templates/passwordRecover.html',
					controller: 'PasswordRecoverController as recover'
				}
			}
		})
		.state('application', {
			url: '/application',
			data: {
				title: 'Apply to join Personal Wine Curator'
			},
			views: {
				main: {
					templateUrl: 'templates/application.html?v=' + BUILD_NUMBER,
					controller: 'ApplicationController as application'
				}
			}
		})
		.state('debug', {
			url: '/debug',
			data: {
				title: 'Debug'
			},
			"views": {
				"main": {
					templateUrl: 'templates/debug.html?v=' + BUILD_NUMBER,
					controller: 'DebugController as debug'
				}
			}
		});

    // if none of the above states are matched, use this as the fallback
    $urlRouterProvider.otherwise('/login');
}

runBlock.$inject = ['$rootScope', '$state', '$stateParams', '$window', 'ENV', 'Utils', 'PwcRepository', 'DialogService', 'UserStore'];

function runBlock($rootScope, $state, $stateParams, $window, ENV, Utils, PwcRepository, DialogService, UserStore) {

    PwcRepository.isOutOfDate().then(function(isOutOfDate){
    	if (isOutOfDate){
			DialogService.versionOutOfDate();
		}
	});

	//ConnectionService.initialize();

	// Hide the accessory bar by default (remove this to show the accessory bar above the keyboard
	// for form inputs)
	if ($window.cordova && $window.cordova.plugins.Keyboard) {
		cordova.plugins.Keyboard.hideKeyboardAccessoryBar(true);
	}

	if ($window.StatusBar) {
		// org.apache.cordova.statusbar required
		StatusBar.styleDefault();
	}

	// add to rootScope for template access
	$rootScope.$state = $state;
	$rootScope.$stateParams = $stateParams;

	// begin layout functionality, @TODO move to a service but still expose to $rootScope
	var layout = {
		"pageTitle": "Personal Wine Curator"
	};

	layout.setPageTitle = function(title){
		layout.pageTitle = title;
	};

	$rootScope.layout = layout;

	$rootScope.$on('$stateChangeStart', function (event, toState) {
		if (toState.data && toState.data.title){
			$rootScope.layout.setPageTitle(toState.data.title);
		}
	});

    $rootScope.$on('$stateChangeSuccess', function (event, toState) {
        // clear pending changes flag
        UserStore.state.hasPendingChanges = false;
    });

	$rootScope.debug = ENV.DEBUG;

	$rootScope.isActive = true;

	$rootScope.isIOSChrome = Utils.agent.isIOSChrome();
}

/**
 * Register and specify modules.
 */
angular.module('pwc.utils', []);
angular.module('pwc.environment', []);
angular.module('pwc.controllers', []);
angular.module('pwc.directives', []);
angular.module('pwc.filters', []);
angular.module('pwc.pouch.user', []);
angular.module('pwc.pouch.system', []);
angular.module('pwc.api', []);
angular.module('pwc.entity', []);
angular.module('pwc.data', []);
angular.module('pwc.model', []);
angular.module('pwc.repositories', []);
angular.module('pwc.agingPotential', []);
angular.module('pwc.events', []);
angular.module('pwc.services.connection', []);
angular.module('pwc.services.wineTable', []);
angular.module('pwc.services.message', []);
angular.module('pwc.services.barcode', []);
angular.module('pwc.services.dialog', []);
angular.module('pwc.services.intercom', []);
angular.module('pwc.state', []);